// Sidebar "NEW" badge configuration. Bump the launch timestamp when shipping
// a new section — the pill auto-hides 7 days later without any maintenance.
export const NEW_BADGE_TTL_MS = 7 * 24 * 60 * 60 * 1000;

export const SIDEBAR_LAUNCH_DATES = {
  explore: new Date('2026-04-22').getTime(),
  bookmarks: new Date('2026-04-22').getTime(),
  tools: new Date('2026-04-28').getTime(),
  prompts: new Date('2026-06-10').getTime(),
  // workflows: new Date('2026-05-04').getTime(),
};

export function isSidebarItemNew(key) {
  const launchedAt = SIDEBAR_LAUNCH_DATES[key];
  return !!launchedAt && Date.now() - launchedAt < NEW_BADGE_TTL_MS;
}
